var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTensflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6666 50.406L39.3333 53.0727V26.6667L34.6666 29.3333V50.406Z",
    fill: "#FFA000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3333 32.2887L28 38.8333V33.1667L39.3333 26.622V32.2887Z",
    fill: "#FFA000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3333 50.406L40.6666 53.0727V26.6667L45.3333 29.3333V50.406Z",
    fill: "#FFB300"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6666 32.2887L52 38.8333V33.1667L40.6666 26.622V32.2887Z",
    fill: "#FFB300"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3334 37.1547V42.2433L48 44.938V39.85L43.3334 37.1547Z",
    fill: "#FFB300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTensflow);
export default __webpack_public_path__ + "static/media/tensflow.a29365ba00dd41f2f175168055c7cc57.svg";
export { ForwardRef as ReactComponent };